import { RootState } from "../../store";
import { createSelector } from "@reduxjs/toolkit";
import { ICountriesState } from "../../interfaces/state";

const selectCountries = (state: RootState): ICountriesState => state.countries;

export const selectCountriesList = createSelector([selectCountries], (countries) => {
    return countries.countries ?? [];
});
